import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { NotificationComponent } from '../notification/notification.component'
import { NotificationsService } from '@notifications/services/notifications.service'

@Component({
  selector: 'app-notification-list',
  standalone: true,
  imports: [NotificationComponent],
  templateUrl: './notification-list.component.html',
  styleUrl: './notification-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationListComponent {
  notificationService = inject(NotificationsService)

  notifications = computed(() => {
    const data = this.notificationService.notifications()
    const ordened = data.sort((a, b) => {
      const dateA = new Date(a.date).getTime()
      const dateB = new Date(b.date).getTime()
      return dateB - dateA
    })

    return ordened
  })
}
